/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import has from 'lodash/has';
import { SearchBox, Dom } from 'react-components';
import { withRouter } from 'react-router';
import GlobalNav from './GlobalNav';
import Link from '../Link/Link';
import Logo from './Logo';
import MobileMenu from './MobileMenu';
import SubMenu from './SubMenu';

class Header extends PureComponent {
  static getCurrentMenu(nav, id) {
    if (nav && id) {
      const filteredNav = nav.filter(n => n.id === id)[0];
      return has(filteredNav, 'items') ? filteredNav.items : null;
    }
    return null;
  }

  static isHash(str) {
    if (str && typeof str === 'string') {
      return str.charAt(0) === '#';
    }
    return null;
  }

  state = {
    isBannerOpen: true,
    isFixedHeader: false,
    isMobileMenuVisible: false,
    isSearchVisible: false,
    isSubMenuVisible: false,
    selectedSubMenu: null,
  };

  componentDidMount() {
    const isDomUsable = Dom.isDomUsable();

    if (isDomUsable) {
      window.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
    const isDomUsable = Dom.isDomUsable();

    if (isDomUsable) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleCloseSubMenu = event => {
    const isSubMenu = event.target.closest('a.is-sub-menu');
    // allows for submenu mouse events to propagate correctly before setting state
    // a bit of a hack IMO, but wasn't sure of a better way, perhaps future me(dja) will figure it out
    if (!isSubMenu) {
      setTimeout(() => {
        this.setState({
          isSubMenuVisible: false,
          selectedSubMenu: null,
        });
      }, 150);
    }
  };

  handleDesktopSearch = event => {
    this.handleSearch(event, this.desktopInput.textInput);
  };

  handleMobileSearch = event => {
    this.handleSearch(event, this.mobileInput.textInput);
  };

  handleScroll = () => {
    const topOffset = document.getElementById('above-header').clientHeight;
    const windowY = window.pageYOffset;
    if (windowY > topOffset && !this.state.isFixedHeader) {
      this.setState({ isFixedHeader: true });
    }
    if (windowY < topOffset && this.state.isFixedHeader) {
      this.setState({ isFixedHeader: false });
    }
  };

  handleSearch = (event, input) => {
    const { history } = this.props;
    event.preventDefault();
    this.toggleSearch(event);
    if (history) {
      history.push(`/search?q=${input.value}`);
      input.value = ''; // eslint-disable-line no-param-reassign
    }
  };

  closeBanner = () => {
    this.setState({
      isBannerOpen: false,
    });
    localStorage.setItem('isCookieBannerOpen', JSON.stringify(false));
  };

  closeSearch = () => {
    this.setState({
      isSearchVisible: false,
    });
  };

  selectSubMenu = id => {
    const { selectedSubMenu } = this.state;
    this.setState({
      selectedSubMenu: selectedSubMenu !== id ? id : null,
    });
  };

  toggleMobileMenu = () => {
    this.setState(
      prevState => ({
        isMobileMenuVisible: !prevState.isMobileMenuVisible,
      }),
      () => {
        this.props.onToggleMobileMenu(this.state.isMobileMenuVisible);
      },
    );
  };

  toggleSubMenu = id => {
    if (this.state.selectSubMenu === id) {
      this.setState({
        isSubMenuVisible: false,
      });
    }
    if (!this.state.selectSubMenu) {
      this.setState({
        isSubMenuVisible: true,
      });
    }
  };

  toggleSearch = event => {
    event.preventDefault();
    this.setState(prevState => ({
      isSearchVisible: !prevState.isSearchVisible,
    }));
  };

  render() {
    const {
      currentNav,
      fenderConnect,
      fenderConnectProfile,
      globalNavData,
      isSearchActive,
      logo,
      navItems,
      onMobileSearchClick,
      onSearchClick,
      promoColor,
      promoContent,
      searchContent,
      searchPlaceholder,
      titles,
      cta,
      onClick,
    } = this.props;
    const baseHeaderStyle = 'relative bg-white bb b--black-10 futura-heavy w-100 h3';
    const filteredNavItems =
      navItems && Array.isArray(navItems)
        ? navItems.filter(navItem => navItem.id !== 'home')
        : null;
    const currentMenu = Header.getCurrentMenu(filteredNavItems, this.state.selectedSubMenu);
    const dropdownYPos = '4rem';
    const headerStateStyle = this.state.isFixedHeader
      ? `${!this.state.isMobileMenuVisible ? 'fixed' : ''} top-0 z-5`
      : '';
    const headerStyle = `${baseHeaderStyle} ${headerStateStyle}`;
    const linkStyle = 'db relative mt3 ttu f8 truncate dark-gray no-underline';
    const pixel = '0.3125rem';
    const userEmail =
      fenderConnectProfile && fenderConnectProfile.email ? fenderConnectProfile.email : '';

    return (
      <div className="header top-0 left-0 z-5 w-100" onScroll={this.handleScroll}>
        <div id="above-header">
          <GlobalNav
            fenderConnect={fenderConnect}
            globalNavData={globalNavData}
            currentNavStr={currentNav}
          />
          {promoContent && this.state.isBannerOpen ? (
            <div className={`w-100 relative f6 v-mid white bb b--light-gray bg-${promoColor}`}>
              <div
                className="f6 fw1 futura-book tc-l tl pr4"
                style={{ padding: '0.85rem 1rem 0.8rem 1rem' }}
              >
                {promoContent}
                <button
                  type="button"
                  className="absolute right-0 pa2 pr3 no-underline button-reset bg-transparent outline-0 bn pointer"
                  style={{ top: '.3rem' }}
                  onClick={this.closeBanner}
                >
                  <span className="icon-x white" />
                </button>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
        {this.state.isFixedHeader && !this.state.isMobileMenuVisible ? (
          <div style={{ height: '4rem' }} />
        ) : (
          ''
        )}
        <header className={`${headerStyle}`} data-id="mega-nav">
          <div
            className={`center h-100 flex justify-between z-5 relative bg-white${
              cta ? ' w-100' : ''
            }`}
          >
            <div className="flex items-center">
              <Logo link={logo.link} linkDataId={logo.linkDataId} linkStyle="pl3 pl4-l">
                {logo.image}
              </Logo>
              <ul className="list pl0 ma0 ml3 flex-l dn items-center self-stretch">
                {Array.isArray(filteredNavItems)
                  ? filteredNavItems.map(navItem => (
                      <li
                        className={`flex items-center self-stretch mh3 bb
                      ${navItem.id === this.state.selectedSubMenu ? 'b--blue' : 'b--transparent'}`}
                        key={navItem.id}
                        style={{ borderWidth: pixel }}
                        data-id={`mega-nav-label-${navItem.label.toLowerCase()}`}
                      >
                        {navItem.items || !navItem.url || Header.isHash(navItem.url) ? (
                          <a
                            className={`${linkStyle} ${navItem.items ? 'is-sub-menu pr3' : ''}
                          ${navItem.id === this.state.selectedSubMenu ? 'blue' : 'dark-gray'}`}
                            href={Header.isHash(navItem.url) ? navItem.url : ''}
                            onClick={event => {
                              event.preventDefault();
                              if (navItem.items) {
                                this.selectSubMenu(navItem.id);
                                this.toggleSubMenu(navItem.id);
                              }
                              if (!navItem.items && !navItem.url) {
                                onClick(navItem.url);
                              }
                            }}
                          >
                            <span className={`${navItem['class-names'] || ''}`}>
                              {navItem.label}
                            </span>
                            {navItem.items ? (
                              <span
                                className={`${navItem['class-names'] ||
                                  ''} f6 pl2 absolute right-0`}
                                style={{ top: `-${pixel}` }}
                              >
                                {navItem.id === this.state.selectedSubMenu ? (
                                  <i className="icon-triangle-up" />
                                ) : (
                                  <i className="icon-triangle-down" />
                                )}
                              </span>
                            ) : null}
                          </a>
                        ) : (
                          <Link
                            className={`${linkStyle}`}
                            target={navItem.target ? navItem.target : ''}
                            to={!navItem.url ? '' : navItem.url}
                            trackEvent={{
                              eventType: 'Click Main Navigation',
                              properties: {
                                navigation_core: navItem.label,
                                email: userEmail,
                              },
                            }}
                          >
                            <span className={`${navItem['class-names'] || ''}`}>
                              {navItem.label}
                            </span>
                          </Link>
                        )}
                      </li>
                    ))
                  : null}
              </ul>
              <SubMenu
                email={userEmail}
                isVisible={this.state.isSubMenuVisible}
                menu={currentMenu}
                onClickOutside={this.handleCloseSubMenu}
                onSubMenuClick={this.handleCloseSubMenu}
              />
            </div>
            <div className="flex items-center">
              {searchPlaceholder && !onSearchClick ? (
                <div>
                  <div className="db dn-l ml4 ml3-l mr3">
                    <a
                      data-id="header-search-icon-mobile"
                      href=""
                      className="relative no-underline dark-gray pl1 f3"
                      onClick={this.toggleSearch}
                    >
                      <span className="icon-search" />
                    </a>
                    <div
                      className={`absolute z-5 shadow-5 left-0 w-100 h3 overflow-hidden ${
                        this.state.isSearchVisible ? 'flex' : 'dn'
                      }`} // eslint-disable-line
                      style={{
                        top: dropdownYPos,
                        marginTop: '-0.10rem',
                      }}
                    >
                      <div
                        className="flex flex-auto"
                        style={{ marginLeft: '-0.10rem', marginRight: '-0.10rem' }}
                      >
                        <form
                          className="flex flex-auto w-100"
                          onSubmit={this.handleMobileSearch}
                          method="POST"
                        >
                          <SearchBox
                            ref={input => {
                              this.mobileInput = input;
                            }}
                            size="small"
                            spacing="pv2 ph3"
                            placeholder={searchPlaceholder}
                          />
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="dn db-l mw6 mr4">
                    <form onSubmit={this.handleDesktopSearch} method="POST">
                      <SearchBox
                        ref={input => {
                          this.desktopInput = input;
                        }}
                        size="small"
                        placeholder={searchPlaceholder}
                      />
                    </form>
                  </div>
                </div>
              ) : (
                ''
              )}
              {onSearchClick ? (
                <div className="h-100">
                  <button
                    type="button"
                    data-id="header-search-btn"
                    className="dn db-l bn outline-0 h-100 pa0 bg-transparent"
                    onClick={onSearchClick}
                  >
                    <div className={`b--black-10 h-100${!cta ? ' bl' : ''}`}>
                      <div className="bt bw2 b--white h-100">
                        <div
                          className={`flex items-center pv0 ph3 h-100 bw2 pointer${
                            !cta ? ' bb' : ''
                          } ${isSearchActive ? 'b--blue' : 'b--white'}`}
                        >
                          <span className="icon-search dark-gray f3 ph1" />
                        </div>
                      </div>
                    </div>
                  </button>
                  <button
                    type="button"
                    className="bn outline-0 dn-l h-100 bg-transparent"
                    data-id="header-search-btn-mobile"
                    onClick={() => {
                      if (onMobileSearchClick) {
                        onMobileSearchClick();
                      } else {
                        onSearchClick();
                      }
                    }}
                  >
                    <span className="icon-search dark-gray f2 ph3" />
                  </button>
                </div>
              ) : null}
              <button
                type="button"
                className="db dn-l dark-gray outline-0 button-reset bn bg-transparent pointer pl0 pr3"
                data-id="header-menu-btn-mobile"
                onClick={this.toggleMobileMenu}
              >
                <span className="f3 icon-menu" style={{ transition: 'opacity .15s ease-in' }} />
              </button>
              <MobileMenu
                currentNav={currentNav}
                fenderConnect={fenderConnect}
                fenderConnectProfile={fenderConnectProfile}
                globalNavData={globalNavData}
                isVisible={this.state.isMobileMenuVisible}
                onClick={onClick}
                onCloseMenu={this.toggleMobileMenu}
                onSelectSubMenu={id => this.selectSubMenu(id)}
                navItems={navItems}
                selectedSubMenu={this.state.selectedSubMenu}
                titles={titles}
              />
              {cta ? (
                <div className={`ph3${cta.wrapperClassName ? ` ${cta.wrapperClassName}` : ''}`}>
                  <button
                    type="button"
                    onClick={cta.onClick}
                    data-id={cta.dataId}
                    className={`button pointer outline-0 dib tc ttu br2 lh-solid f7 ph3-ns ph2 pv2 bg-red futura-heavy lh-solid white${
                      cta.className ? ` ${cta.className}` : ''
                    }`}
                    style={{ letterSpacing: '1px' }}
                  >
                    <span className="dib mh2 mv1">{cta.text}</span>
                  </button>
                </div>
              ) : null}
            </div>
          </div>
          {isSearchActive ? <div className="absolute right-0 z-3">{searchContent}</div> : null}
        </header>
      </div>
    );
  }
}

Header.propTypes = {
  currentNav: PropTypes.string,
  fenderConnect: PropTypes.element.isRequired,
  fenderConnectProfile: PropTypes.shape({
    email: PropTypes.string,
  }),
  globalNavData: PropTypes.shape({}).isRequired,
  isSearchActive: PropTypes.bool,
  logo: PropTypes.shape({
    image: PropTypes.node,
    link: PropTypes.string,
  }),
  navItems: PropTypes.arrayOf(PropTypes.shape({})),
  onClick: PropTypes.func,
  onSearchClick: PropTypes.func,
  onMobileSearchClick: PropTypes.func,
  onToggleMobileMenu: PropTypes.func,
  promoContent: PropTypes.element,
  promoColor: PropTypes.string,
  searchContent: PropTypes.node,
  searchPlaceholder: PropTypes.string,
  titles: PropTypes.shape({
    site: PropTypes.string,
    connect: PropTypes.string,
    apps: PropTypes.string,
  }),
  cta: PropTypes.shape({
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    dataId: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    wrapperClassName: PropTypes.string,
  }),
};

Header.defaultProps = {
  currentNav: '',
  fenderConnectProfile: null,
  isSearchActive: false,
  logo: {
    image: null,
    link: null,
  },
  navItems: null,
  onClick: () => {},
  onSearchClick: null,
  onMobileSearchClick: null,
  onToggleMobileMenu: () => {},
  promoContent: null,
  promoColor: 'red',
  searchContent: null,
  searchPlaceholder: null,
  titles: {
    site: 'Fender',
    connect: 'Fender Connect',
    apps: 'Fender Apps',
  },
  cta: null,
};

export default withRouter(Header);
